/* =========================================================
   Bacci Kid Cloud Portal v7 Crown - FULL REPLACEMENT JS
   Replace the entire contents of assets/bk-cloud-portal-v7.js with this file.
   Includes: guide rotation, quests, rewards, scent lab, controls,
   11-frame Cloud Curator Spotlight Ceremony, device art upload.
   ========================================================= */

(function () {
  "use strict";

  var root = document.querySelector("[data-bkcp7-root]");
  if (!root) return;

  var configEl = root.querySelector("[data-bkcp7-config]");
  var config = {};

  try {
    config = JSON.parse(configEl ? configEl.textContent : "{}");
  } catch (error) {
    console.warn("Bacci Kid Cloud Portal v7 config could not be read.", error);
    config = {};
  }

  var storageKey = "bkCloudPortalV7State";

  var defaultState = {
    activeQuest: "ask-cloud",
    completedQuests: [],
    coins: 0,
    stickers: 0,
    badges: 0,
    stamps: [],
    guideIndex: 0,
    calmMode: false,
    captions: true,
    sound: false,
    language: "en",
    scentMix: [],
    artPlaced: 0,
    lastReward: "Curiosity Spark",
    selectedFrameId: "royal-diamond",
    selectedTier: "tweens",
    selectedSlot: "1",
    selectedArtIndex: 0,
    artSlots: {},
    deviceArt: [],
    cloudCuratorBadgeEarned: false
  };

  var FRAMES = [
    {
      id: "celestial-crown",
      name: "Celestial Crown",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/01-celestial-crown-ultra-bling-frame-transparent_1.png?v=1781114715"
    },
    {
      id: "royal-diamond",
      name: "Royal Diamond Palace",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/02-royal-diamond-palace-ultra-bling-frame-transparent_1.png?v=1781114714"
    },
    {
      id: "ruby-sapphire",
      name: "Ruby Sapphire Regal",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/03-ruby-sapphire-regal-ultra-bling-frame-transparent_2.png?v=1781114714"
    },
    {
      id: "diamond-frost",
      name: "Diamond Frost Moonstone",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/04-diamond-frost-moonstone-ultra-bling-frame-transparent_1.png?v=1781114716"
    },
    {
      id: "solar-topaz",
      name: "Solar Topaz Sunburst",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/05-solar-topaz-sunburst-ultra-bling-frame-transparent__3.png?v=1781114714"
    },
    {
      id: "cosmic-amethyst",
      name: "Cosmic Amethyst Royal",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/06-cosmic-amethyst-royal-ultra-bling-frame-transparent__1.png?v=1781114715"
    },
    {
      id: "lotus-mandala",
      name: "Lotus Mandala Jewel",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/07-lotus-mandala-jewel-ultra-bling-frame-transparent_1.png?v=1781114715"
    },
    {
      id: "rose-gold",
      name: "Rose Gold Couture Diamond",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/08-rose-gold-couture-diamond-ultra-bling-frame-transparent_1.png?v=1781114715"
    },
    {
      id: "byzantine-cathedral",
      name: "Byzantine Cathedral Jewel",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/09-byzantine-cathedral-jewel-ultra-bling-frame-transparent_1.png?v=1781114714"
    },
    {
      id: "futuristic-hologold",
      name: "Futuristic HoloGold Diamond",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/10-futuristic-hologold-diamond-ultra-bling-frame-transparent_1.png?v=1781114715"
    },
    {
      id: "baroque-gold",
      name: "Baroque Gold Portal",
      url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/baroque-gold-portal-frame-transparent_1.png?v=1781114714"
    }
  ];

  var ART_BY_TIER = {
    toddler: [
      {
        title: "Toddler Heartopedia Art",
        source: "Toddler Heartopedia",
        image: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bachi-png_1.png?v=1780964836"
      }
    ],
    kids: [
      {
        title: "Kids Heartopedia Art",
        source: "Kids Heartopedia",
        image: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Bengal_Kitten_text_removed.png?v=1780965407"
      }
    ],
    tweens: [
      {
        title: "Tween Bubble Tea Art",
        source: "Tween Heartopedia",
        image: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/ChatGPT_Image_May_6_2026_08_29_26_PM_7.png?v=1778856563"
      }
    ],
    braveTeens: [
      {
        title: "Brave Teen Heartopedia Art",
        source: "Brave Teen Heartopedia",
        image: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Jun_4_2026_06_20_26_PM_2.png?v=1780611697"
      }
    ],
    grownups: [
      {
        title: "Grown-Up Heartopedia Art",
        source: "Grown-Up Heartopedia",
        image: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/ChatGPT_Image_Jun_8_2026_09_47_27_PM.png?v=1780969814"
      }
    ],
    seniors: [
      {
        title: "Senior Heartopedia Art",
        source: "Senior Heartopedia",
        image: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/ChatGPT_Image_Jun_8_2026_10_08_44_PM_2.png?v=1780970937"
      }
    ],
    solo: [
      {
        title: "Solo Dreamer Heartopedia Art",
        source: "Solo Dreamer Mode",
        image: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Can_you_please_share_your_feelings_03de94c8-25ee-4fb7-8a50-95ed7329eb1b.png?v=1781225458"
      }
    ]
  };

  function $(selector, parent) {
    return (parent || root).querySelector(selector);
  }

  function $$(selector, parent) {
    return Array.prototype.slice.call((parent || root).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function readState() {
    try {
      var raw = localStorage.getItem(storageKey);
      var parsed = raw ? JSON.parse(raw) : {};
      return Object.assign({}, defaultState, parsed, {
        completedQuests: Array.isArray(parsed.completedQuests) ? parsed.completedQuests : defaultState.completedQuests.slice(),
        stamps: Array.isArray(parsed.stamps) ? parsed.stamps : defaultState.stamps.slice(),
        scentMix: Array.isArray(parsed.scentMix) ? parsed.scentMix : defaultState.scentMix.slice(),
        artSlots: parsed.artSlots && typeof parsed.artSlots === "object" ? parsed.artSlots : {},
        deviceArt: Array.isArray(parsed.deviceArt) ? parsed.deviceArt : []
      });
    } catch (error) {
      return Object.assign({}, defaultState);
    }
  }

  var state = readState();

  function saveState() {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      console.warn("Bacci Kid Cloud Portal v7 state could not be saved.", error);
    }
  }

  function getFrame(id) {
    for (var i = 0; i < FRAMES.length; i += 1) {
      if (FRAMES[i].id === id) return FRAMES[i];
    }
    return FRAMES[0];
  }

  function getQuest(id) {
    var quests = config.quests || [];
    for (var i = 0; i < quests.length; i += 1) {
      if (quests[i].id === id) return quests[i];
    }
    return quests[0] || null;
  }

  function getActiveQuest() {
    return getQuest(state.activeQuest);
  }

  function showToast(message) {
    var toast = $("[data-bkcp7-toast]");
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 3400);
  }

  function updateGuide() {
    var guides = config.guides || [];
    if (!guides.length) return;
    var guide = guides[state.guideIndex % guides.length];
    var image = $("[data-bkcp7-guide-img]");
    var name = $("[data-bkcp7-guide-name]");
    var role = $("[data-bkcp7-guide-role]");
    var message = $("[data-bkcp7-guide-message]");
    if (image) {
      image.src = guide.image;
      image.alt = (guide.name || "Bacci Kid") + " " + (guide.role || "guide");
    }
    if (name) name.textContent = guide.name || "Bacci Kid Guide";
    if (role) role.textContent = guide.role || "Wonder Guide";
    if (message) message.textContent = guide.message || "Follow the light.";
  }

  function changeGuide() {
    var guides = config.guides || [];
    if (!guides.length) return;
    state.guideIndex = (Number(state.guideIndex || 0) + 1) % guides.length;
    saveState();
    updateGuide();
    showToast("Your Wonderverse guide changed.");
  }

  function updateQuestUI() {
    var quest = getActiveQuest();
    if (!quest) return;

    var title = $("[data-bkcp7-active-title]");
    var prompt = $("[data-bkcp7-active-prompt]");
    var progressLabel = $("[data-bkcp7-progress-label]");
    var progressBar = $("[data-bkcp7-progress-bar]");
    var nextReward = $("[data-bkcp7-next-reward]");

    if (title) title.textContent = quest.title;
    if (prompt) prompt.textContent = quest.prompt;
    if (nextReward) nextReward.textContent = state.lastReward || quest.reward || "Wonder Reward";

    var total = (config.quests || []).length || 5;
    var completed = state.completedQuests.length;
    var percent = Math.min(100, Math.round((completed / total) * 100));

    if (progressLabel) progressLabel.textContent = completed + " / " + total + " completed";
    if (progressBar) progressBar.style.width = percent + "%";

    $$(".bkcp7-quest-node").forEach(function (node) {
      var id = node.getAttribute("data-quest-id");
      node.classList.toggle("is-active", id === state.activeQuest);
      node.classList.toggle("is-complete", state.completedQuests.indexOf(id) !== -1);
    });

    updateRewardsUI();
  }

  function setActiveQuest(id) {
    var quest = getQuest(id);
    if (!quest) return;
    state.activeQuest = id;
    saveState();
    updateQuestUI();
    var answer = $("[data-bkcp7-quest-answer]");
    if (answer) answer.value = "";
    showToast(quest.title + " is now your active quest.");
  }

  function rewardForQuest(quest) {
    if (!quest) return;
    if (quest.id === "ask-cloud") {
      state.stickers += 1;
      state.lastReward = "Curiosity Spark Sticker";
    } else if (quest.id === "catch-ripple") {
      state.coins += 5;
      state.lastReward = "5 Bacci Kid Gold Coins";
    } else if (quest.id === "gentle-breath") {
      state.stickers += 1;
      state.lastReward = "Calm Glow Sticker";
    } else if (quest.id === "kindness-chime") {
      if (state.stamps.indexOf("Cloud Sensor Stamp") === -1) state.stamps.push("Cloud Sensor Stamp");
      state.lastReward = "Cloud Sensor Passport Stamp";
    } else if (quest.id === "starlight-share") {
      state.coins += 25;
      state.lastReward = "Sealed Gate Glow";
    }
  }

  function completeActiveQuest() {
    var quest = getActiveQuest();
    if (!quest) return;

    if (state.completedQuests.indexOf(quest.id) === -1) {
      state.completedQuests.push(quest.id);
      rewardForQuest(quest);
      showToast("Quest complete. You earned " + state.lastReward + ".");
    } else {
      showToast("This quest is already complete. Choose another glowing step.");
    }

    var quests = config.quests || [];
    for (var i = 0; i < quests.length; i += 1) {
      if (state.completedQuests.indexOf(quests[i].id) === -1) {
        state.activeQuest = quests[i].id;
        break;
      }
    }

    saveState();
    updateQuestUI();
  }

  function updateRewardsUI() {
    var coins = Number(state.coins || 0);
    var stickers = Number(state.stickers || 0);
    var badges = Number(state.badges || 0);

    $$("[data-bkcp7-coins], [data-bkcp7-earned-coins]").forEach(function (el) { el.textContent = coins; });
    $$("[data-bkcp7-stickers], [data-bkcp7-earned-stickers]").forEach(function (el) { el.textContent = stickers; });
    $$("[data-bkcp7-badges], [data-bkcp7-earned-badges]").forEach(function (el) { el.textContent = badges; });

    var level = $("[data-bkcp7-level]");
    if (level) {
      if (state.completedQuests.length >= 5 || state.artPlaced >= 1) level.textContent = "Level 5 Cloud Curator";
      else if (state.completedQuests.length >= 3) level.textContent = "Level 3 Cloud Explorer";
      else level.textContent = "Level 1 Dreamer";
    }

    var nextReward = $("[data-bkcp7-next-reward]");
    if (nextReward) nextReward.textContent = state.lastReward || "Curiosity Spark";
  }

  function addScent(value) {
    if (!value) return;
    if (state.scentMix.indexOf(value) === -1) state.scentMix.push(value);
    if (state.scentMix.length > 4) state.scentMix.shift();
    saveState();
    updateScentUI();
    showToast("Cloud Scent added: " + value + ".");
  }

  function updateScentUI() {
    var result = $("[data-bkcp7-scent-result]");
    if (!result) return;
    if (!state.scentMix.length) {
      result.textContent = "Your Cloud Scent will appear here.";
      return;
    }
    result.textContent = "Your Cloud Scent smells like " + state.scentMix.join(", ") + ", kindness, imagination, and Wonderverse sparkle.";
  }

  function setCalmMode(forceValue) {
    state.calmMode = typeof forceValue === "boolean" ? forceValue : !state.calmMode;
    root.classList.toggle("is-calm-mode", state.calmMode);
    saveState();
    var button = $("[data-bkcp7-toggle-calm]");
    if (button) button.textContent = state.calmMode ? "Cinematic Mode" : "Calm Mode";
    showToast(state.calmMode ? "Calm Mode is on." : "Cinematic Wonder Mode is on.");
  }

  function toggleCaptions() {
    state.captions = !state.captions;
    saveState();
    var button = $("[data-bkcp7-toggle-captions]");
    if (button) button.textContent = state.captions ? "CC On" : "CC Off";
    showToast(state.captions ? "Captions are on." : "Captions are off.");
  }

  function toggleSound() {
    state.sound = !state.sound;
    saveState();
    $$("video").forEach(function (video) { video.muted = !state.sound; });
    var button = $("[data-bkcp7-toggle-sound]");
    if (button) button.textContent = state.sound ? "Sound On" : "Sound Off";
    showToast(state.sound ? "Sound is on." : "Sound is off.");
  }

  function setLanguage(lang) {
    state.language = lang || "en";
    root.setAttribute("lang", state.language);
    saveState();
    showToast(state.language === "ko" ? "한국어 모드가 준비되었습니다." : "English mode is ready.");
  }

  function openPanelHtml(html) {
    var panel = $("[data-bkcp7-panel]");
    var content = $("[data-bkcp7-panel-content]");
    if (!panel || !content) return;
    content.innerHTML = html;
    try { panel.showModal(); } catch (error) { panel.setAttribute("open", "open"); }
  }

  function closePanel() {
    var panel = $("[data-bkcp7-panel]");
    if (!panel) return;
    try { panel.close(); } catch (error) { panel.removeAttribute("open"); }
  }

  function openInfoPanel(type) {
    var html = "";
    if (type === "guide") {
      var guides = config.guides || [];
      var guide = guides[state.guideIndex % guides.length] || {};
      html = "<h3>Meet Your Guide</h3><p><strong>" + escapeHtml(guide.name || "Cloud Guide") + "</strong> helps you move through kindness, imagination, creativity, and wonder.</p><p>" + escapeHtml(guide.message || "Your guide is ready.") + "</p>";
    } else if (type === "passport") {
      html = "<h3>Wonderverse Passport</h3><p>Your passport keeps track of discoveries, stamps, badges, stickers, and fun-only Bacci Kid Gold Coins on this device.</p><p><strong>Completed quests:</strong> " + state.completedQuests.length + "</p><p><strong>Stamps:</strong> " + (state.stamps.length ? escapeHtml(state.stamps.join(", ")) : "None yet") + "</p>";
    } else {
      html = "<h3>Bacci Kid Cloud Portal</h3><p>This is one immersive museum portal inside the Bacci Kid Infinite Wonderverse.</p>";
    }
    openPanelHtml(html);
  }

  function startHeroVideo() {
    var video = $("[data-bkcp7-video='hero']");
    if (!video) return;
    video.muted = !state.sound;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") playPromise.catch(function () {});
  }

  function getDeviceArt() {
    var out = Array.isArray(state.deviceArt) ? state.deviceArt.slice() : [];
    var keys = ["bkArtVaultV2", "BKArtVaultV2", "bkArtVault", "BKArtVault"];

    keys.forEach(function (key) {
      try {
        var raw = localStorage.getItem(key);
        if (!raw) return;
        var parsed = JSON.parse(raw);
        var items = Array.isArray(parsed) ? parsed : Array.isArray(parsed.items) ? parsed.items : Array.isArray(parsed.art) ? parsed.art : [];
        items.forEach(function (item, index) {
          var image = item.image || item.imageUrl || item.url || item.src || item.dataUrl || item.preview;
          if (!image) return;
          out.push({
            title: item.title || item.name || "My Heartopedia Artwork",
            source: "Saved on this device",
            image: image,
            id: item.id || "device-art-" + index
          });
        });
      } catch (error) {}
    });

    var seen = {};
    return out.filter(function (item) {
      if (!item || !item.image || seen[item.image]) return false;
      seen[item.image] = true;
      return true;
    });
  }

  function getTierArt(tier) {
    var localArt = getDeviceArt();
    var builtIn = ART_BY_TIER[tier] || ART_BY_TIER.tweens || [];
    return localArt.concat(builtIn);
  }

  function renderFramePicker() {
    var picker = $(".bkcp7-frame-picker");
    if (!picker) return;
    picker.innerHTML = "<h3>Choose a jewel frame</h3><div class='bkcp7-frame-gallery'>" + FRAMES.map(function (frame) {
      var selected = frame.id === state.selectedFrameId ? " is-selected" : "";
      return "<button type='button' class='bkcp7-frame-choice" + selected + "' data-bkcp7-v72b-frame='" + escapeHtml(frame.id) + "'><img src='" + escapeHtml(frame.url) + "' alt='" + escapeHtml(frame.name) + "'><strong>" + escapeHtml(frame.name) + "</strong></button>";
    }).join("") + "</div>";
  }

  function ensureWallToolbar() {
    var wall = $(".bkcp7-wall");
    if (!wall) return;
    var toolbar = $(".bkcp7-wall-toolbar", wall);
    if (!toolbar) {
      toolbar = document.createElement("div");
      toolbar.className = "bkcp7-wall-toolbar";
      toolbar.innerHTML = "<button type='button' data-bkcp7-v72b-show-all>Show All Frames</button><button type='button' data-bkcp7-v72b-open-art>Choose More Art</button>";
      wall.appendChild(toolbar);
    }
  }

  function renderWall() {
    var wall = $(".bkcp7-wall");
    if (!wall) return;

    $$(".bkcp7-wall-slot", wall).forEach(function (slot) {
      var slotId = slot.getAttribute("data-bkcp7-wall-slot");
      var art = state.artSlots && state.artSlots[slotId];
      slot.classList.remove("is-ceremony");

      if (!art) {
        slot.classList.remove("is-filled", "is-spotlight");
        slot.style.removeProperty("--bkcp7-art");
        slot.style.removeProperty("--bkcp7-frame");
        slot.innerHTML = "<span>+</span><strong>Frame Slot " + escapeHtml(slotId) + "</strong>";
        return;
      }

      var frame = getFrame(art.frameId);
      slot.classList.add("is-filled");
      slot.style.setProperty("--bkcp7-art", "url('" + art.image + "')");
      slot.style.setProperty("--bkcp7-frame", "url('" + frame.url + "')");
      slot.innerHTML = "<span aria-hidden='true'>+</span><strong>" + escapeHtml(art.title || "Heartopedia Art") + "</strong><div class='bkcp7-art-meta'><strong>" + escapeHtml(art.title || "Heartopedia Art") + "</strong><small>" + escapeHtml(art.source || "Heartopedia") + "</small></div>";
    });

    ensureWallToolbar();
  }

  function refreshModalSelections() {
    var content = $("[data-bkcp7-panel-content]");
    if (!content) return;

    $$("[data-bkcp7-v72b-tier]", content).forEach(function (button) {
      button.classList.toggle("is-selected", button.getAttribute("data-bkcp7-v72b-tier") === state.selectedTier);
    });

    $$("[data-bkcp7-v72b-slot]", content).forEach(function (button) {
      button.classList.toggle("is-selected", button.getAttribute("data-bkcp7-v72b-slot") === String(state.selectedSlot));
    });

    $$("[data-bkcp7-v72b-art]", content).forEach(function (button) {
      button.classList.toggle("is-selected", Number(button.getAttribute("data-bkcp7-v72b-art")) === Number(state.selectedArtIndex));
    });

    $$("[data-bkcp7-v72b-frame]", content).forEach(function (button) {
      button.classList.toggle("is-selected", button.getAttribute("data-bkcp7-v72b-frame") === state.selectedFrameId);
    });
  }

  function openArtModal() {
    var frame = getFrame(state.selectedFrameId);
    var artItems = getTierArt(state.selectedTier);

    if (state.selectedArtIndex >= artItems.length) state.selectedArtIndex = 0;

    var html = "";
    html += "<div class='bkcp7-art-modal'>";
    html += "<h3>Cloud Curator Spotlight Ceremony</h3>";
    html += "<p>Choose Heartopedia artwork, choose a jewel frame, choose a museum slot, then hang your art in the Cloud Museum.</p>";
    html += "<div class='bkcp7-device-note'>Device-only: saved or uploaded artwork stays on this device. Nothing is uploaded to a server by this Cloud Portal feature.</div>";
    html += "<div class='bkcp7-modal-steps'><span><b>1.</b> Pick Heartopedia art</span><span><b>2.</b> Choose a jewel frame</span><span><b>3.</b> Spotlight the museum wall</span></div>";

    html += "<div class='bkcp7-tier-tabs'>";
    html += "<button type='button' data-bkcp7-v72b-tier='toddler'>Toddler</button>";
    html += "<button type='button' data-bkcp7-v72b-tier='kids'>Kids</button>";
    html += "<button type='button' data-bkcp7-v72b-tier='tweens'>Tweens</button>";
    html += "<button type='button' data-bkcp7-v72b-tier='braveTeens'>Brave Teens</button>";
    html += "<button type='button' data-bkcp7-v72b-tier='grownups'>Grown-Ups</button>";
    html += "<button type='button' data-bkcp7-v72b-tier='seniors'>Seniors</button>";
    html += "<button type='button' data-bkcp7-v72b-tier='solo'>Solo Dreamer</button>";
    html += "</div>";

    html += "<div class='bkcp7-art-slot-row' aria-label='Choose museum frame slot'>";
    html += "<button type='button' data-bkcp7-v72b-slot='1'>Frame Slot 1</button>";
    html += "<button type='button' data-bkcp7-v72b-slot='2'>Frame Slot 2</button>";
    html += "<button type='button' data-bkcp7-v72b-slot='3'>Frame Slot 3</button>";
    html += "<button type='button' data-bkcp7-v72b-slot='4'>Frame Slot 4</button>";
    html += "</div>";

    html += "<div class='bkcp7-modal-frame-preview'><img src='" + escapeHtml(frame.url) + "' alt='" + escapeHtml(frame.name) + "'><div><strong>" + escapeHtml(frame.name) + "</strong><small>This jewel frame will surround the selected Heartopedia artwork during the spotlight ceremony.</small></div></div>";

    html += "<div class='bkcp7-frame-gallery'>" + FRAMES.map(function (item) {
      var selected = item.id === state.selectedFrameId ? " is-selected" : "";
      return "<button type='button' class='bkcp7-frame-choice" + selected + "' data-bkcp7-v72b-frame='" + escapeHtml(item.id) + "'><img src='" + escapeHtml(item.url) + "' alt='" + escapeHtml(item.name) + "'><strong>" + escapeHtml(item.name) + "</strong></button>";
    }).join("") + "</div>";

    html += "<label class='bkcp7-mini-btn' style='width:fit-content; cursor:pointer;'>Use My Device Artwork<input type='file' accept='image/*' data-bkcp7-v72b-upload style='display:none;'></label>";

    html += "<div class='bkcp7-art-grid'>" + artItems.map(function (art, index) {
      var selected = index === state.selectedArtIndex ? " is-selected" : "";
      return "<button type='button' class='bkcp7-art-choice" + selected + "' data-bkcp7-v72b-art='" + index + "'><img src='" + escapeHtml(art.image) + "' alt='" + escapeHtml(art.title) + "'><span>" + escapeHtml(art.title) + "</span></button>";
    }).join("") + "</div>";

    html += "<button type='button' class='bkcp7-btn bkcp7-btn-gold' data-bkcp7-v72b-place><span>Hang This Art</span><small>Start the museum spotlight ceremony</small></button>";
    html += "</div>";

    openPanelHtml(html);
    refreshModalSelections();
  }

  function placeSelectedArt() {
    var artItems = getTierArt(state.selectedTier);
    var art = artItems[state.selectedArtIndex] || artItems[0];
    if (!art) {
      showToast("Choose or upload artwork first.");
      return;
    }

    var frame = getFrame(state.selectedFrameId);
    var slotId = String(state.selectedSlot || "1");

    state.artSlots[slotId] = {
      title: art.title,
      source: art.source,
      image: art.image,
      frameId: frame.id
    };

    state.artPlaced = Number(state.artPlaced || 0) + 1;

    if (!state.cloudCuratorBadgeEarned) {
      state.cloudCuratorBadgeEarned = true;
      state.badges = Number(state.badges || 0) + 1;
      state.stickers = Number(state.stickers || 0) + 1;
      state.coins = Number(state.coins || 0) + 10;
    }

    state.lastReward = "Cloud Curator Badge";
    saveState();

    renderWall();
    updateRewardsUI();
    closePanel();

    var wall = $(".bkcp7-wall");
    var slot = root.querySelector("[data-bkcp7-wall-slot='" + slotId + "']");

    if (wall && slot) {
      $$(".bkcp7-wall-slot", wall).forEach(function (item) { item.classList.remove("is-spotlight"); });
      wall.classList.add("is-spotlight-mode");
      slot.classList.add("is-spotlight");
      slot.classList.remove("is-ceremony");
      void slot.offsetWidth;
      slot.classList.add("is-ceremony");
      slot.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    showCeremonyBanner(art.title);
    showToast("Your Heartopedia art is now in the Cloud Museum.");
  }

  function showAllFrames() {
    var wall = $(".bkcp7-wall");
    if (!wall) return;
    wall.classList.remove("is-spotlight-mode");
    $$(".bkcp7-wall-slot", wall).forEach(function (slot) { slot.classList.remove("is-spotlight"); });
  }

  function showCeremonyBanner(title) {
    var banner = document.querySelector(".bkcp7-ceremony-banner");
    if (!banner) {
      banner = document.createElement("div");
      banner.className = "bkcp7-ceremony-banner";
      document.body.appendChild(banner);
    }
    banner.innerHTML = "<strong>Your artwork is now in the museum!</strong><span>" + escapeHtml(title || "Heartopedia Art") + " has entered the Cloud Curator Wall.</span>";
    banner.classList.remove("is-visible");
    void banner.offsetWidth;
    banner.classList.add("is-visible");
    window.setTimeout(function () { banner.classList.remove("is-visible"); }, 3100);
  }

  function handleUpload(file) {
    if (!file || !file.type || !file.type.match(/^image\//)) {
      showToast("Please choose an image file.");
      return;
    }

    var reader = new FileReader();
    reader.onload = function () {
      var deviceArt = {
        title: "My Heartopedia Artwork",
        source: "Uploaded on this device",
        image: reader.result
      };
      state.deviceArt = Array.isArray(state.deviceArt) ? state.deviceArt : [];
      state.deviceArt.unshift(deviceArt);
      state.selectedArtIndex = 0;
      saveState();
      openArtModal();
      showToast("Device artwork is ready to hang.");
    };
    reader.readAsDataURL(file);
  }

  function bindEvents() {
    var changeGuideButton = $("[data-bkcp7-change-guide]");
    if (changeGuideButton) changeGuideButton.addEventListener("click", changeGuide);

    var startButton = $("[data-bkcp7-start]");
    if (startButton) {
      startButton.addEventListener("click", function () {
        setActiveQuest("ask-cloud");
        var questSection = document.getElementById("bkcp7-quest");
        if (questSection) questSection.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    var completeButton = $("[data-bkcp7-complete-quest]");
    if (completeButton) completeButton.addEventListener("click", completeActiveQuest);

    var captionsButton = $("[data-bkcp7-toggle-captions]");
    if (captionsButton) captionsButton.addEventListener("click", toggleCaptions);

    var calmButton = $("[data-bkcp7-toggle-calm]");
    if (calmButton) calmButton.addEventListener("click", function () { setCalmMode(); });

    var soundButton = $("[data-bkcp7-toggle-sound]");
    if (soundButton) soundButton.addEventListener("click", toggleSound);

    $$("[data-bkcp7-lang]").forEach(function (button) {
      button.addEventListener("click", function () { setLanguage(button.getAttribute("data-bkcp7-lang")); });
    });

    $$("[data-quest-id]").forEach(function (button) {
      button.addEventListener("click", function () { setActiveQuest(button.getAttribute("data-quest-id")); });
    });

    $$("[data-scent]").forEach(function (button) {
      button.addEventListener("click", function () { addScent(button.getAttribute("data-scent")); });
    });

    $$("[data-bkcp7-open-panel]").forEach(function (button) {
      button.addEventListener("click", function () { openInfoPanel(button.getAttribute("data-bkcp7-open-panel")); });
    });

    var closeButton = $("[data-bkcp7-close-panel]");
    if (closeButton) closeButton.addEventListener("click", closePanel);

    var kindnessButton = $("[data-bkcp7-kindness]");
    if (kindnessButton) {
      kindnessButton.addEventListener("click", function () {
        state.stickers += 1;
        state.lastReward = "Kindness Spark Sticker";
        saveState();
        updateRewardsUI();
        showToast("Kindness Spark shared. You earned a sticker.");
      });
    }

    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target) return;

      var frameChoice = target.closest("[data-bkcp7-v72b-frame]");
      if (frameChoice && root.contains(frameChoice)) {
        event.preventDefault();
        state.selectedFrameId = frameChoice.getAttribute("data-bkcp7-v72b-frame");
        saveState();
        renderFramePicker();
        refreshModalSelections();
        showToast(getFrame(state.selectedFrameId).name + " selected.");
        return;
      }

      var openArt = target.closest("[data-bkcp7-open-art-vault], [data-bkcp7-v72b-open-art]");
      if (openArt && root.contains(openArt)) {
        event.preventDefault();
        event.stopPropagation();
        openArtModal();
        return;
      }

      var wallSlot = target.closest(".bkcp7-wall-slot");
      if (wallSlot && root.contains(wallSlot)) {
        event.preventDefault();
        event.stopPropagation();
        state.selectedSlot = wallSlot.getAttribute("data-bkcp7-wall-slot") || "1";
        saveState();
        openArtModal();
        return;
      }

      var tierButton = target.closest("[data-bkcp7-v72b-tier]");
      if (tierButton) {
        event.preventDefault();
        state.selectedTier = tierButton.getAttribute("data-bkcp7-v72b-tier");
        state.selectedArtIndex = 0;
        saveState();
        openArtModal();
        return;
      }

      var slotButton = target.closest("[data-bkcp7-v72b-slot]");
      if (slotButton) {
        event.preventDefault();
        state.selectedSlot = slotButton.getAttribute("data-bkcp7-v72b-slot");
        saveState();
        refreshModalSelections();
        return;
      }

      var artButton = target.closest("[data-bkcp7-v72b-art]");
      if (artButton) {
        event.preventDefault();
        state.selectedArtIndex = Number(artButton.getAttribute("data-bkcp7-v72b-art"));
        saveState();
        refreshModalSelections();
        return;
      }

      var placeButton = target.closest("[data-bkcp7-v72b-place]");
      if (placeButton) {
        event.preventDefault();
        placeSelectedArt();
        return;
      }

      var showAllButton = target.closest("[data-bkcp7-v72b-show-all]");
      if (showAllButton && root.contains(showAllButton)) {
        event.preventDefault();
        showAllFrames();
        return;
      }
    }, true);

    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target) return;
      var upload = target.closest("[data-bkcp7-v72b-upload]");
      if (!upload) return;
      handleUpload(upload.files && upload.files[0]);
    }, true);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closePanel();
    });
  }

  function init() {
    root.classList.toggle("is-calm-mode", state.calmMode);
    root.setAttribute("lang", state.language || "en");

    updateGuide();
    updateQuestUI();
    updateScentUI();
    updateRewardsUI();
    renderFramePicker();
    renderWall();
    bindEvents();
    startHeroVideo();

    var captionsButton = $("[data-bkcp7-toggle-captions]");
    if (captionsButton) captionsButton.textContent = state.captions ? "CC On" : "CC Off";

    var soundButton = $("[data-bkcp7-toggle-sound]");
    if (soundButton) soundButton.textContent = state.sound ? "Sound On" : "Sound Off";

    var calmButton = $("[data-bkcp7-toggle-calm]");
    if (calmButton) calmButton.textContent = state.calmMode ? "Cinematic Mode" : "Calm Mode";
  }

  init();
})();